var React = require('react');

function Arrow1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".stroke{fill:none;stroke:#1c1c1c;stroke-linecap:round;stroke-width:3px;}")),React.createElement("title",{"key":1},"arrow1"),React.createElement("g",{"id":"a2ecf403-e309-4649-84f0-1e131dac3236","data-name":"Group 214","key":2},[React.createElement("path",{"id":"a5e0413e-122e-4d62-b48b-2c88af2b4d1f","data-name":"Path 572","className":"stroke","d":"M194.40131,34.53014S74.5322,89.09468,9.45453,8.46529","key":0}),React.createElement("path",{"id":"f7b17fdc-bca4-4095-9397-a6d2e1971c48","data-name":"Path 573","className":"stroke","d":"M45.784,4.51806C39.18087,11.36445,1.27334,2.07819,1.501,1.50668S10.27508,37.229,16.3976,44.8203","key":1})])]);
}

Arrow1.defaultProps = {"id":"b44c945b-fba2-4588-b7d2-ecd0442af7b6","data-name":"Layer 1","viewBox":"0 0 195.90131 54.07648"};

module.exports = Arrow1;

Arrow1.default = Arrow1;
